﻿import axios from 'axios';
import qs from 'qs'
import { ref, onMounted, onUnmounted } from 'vue';
//import { useRouter } from 'vue-router';
//import * as bootstrap from 'bootstrap'
import { Local, getToken, decryptJWT, getJWTDate, getRefreshToken, Session } from '@/utils/AxiosToken';
import { getModel } from "@/views/pendingorders/OrderBLL"

//export const baseUrl = 'http://localhost:62495/';
//export const baseUrl = 'https://localhost:7193/';//your local test port.
//please dont change baseUrl define when you push to DEV branch. by dagger.li2024-07-08
export const baseUrl = process.env.NODE_ENV === "production" ? "API/" : "http://172.16.1.44:8088/API/";
// export const baseUrl = process.env.NODE_ENV === "production" ? "API/" : "http://172.16.1.44:8089/API/"; //排除SantaFe测试单

// export const oldwebbaseUrl = process.env.NODE_ENV === "production" ? "NormanAuPrint/" : "http://172.16.1.44:8088/NormanAuPrint/";

//export const publicStaticPath = process.env.NODE_ENV === "production" ? "/NormanAustralia/" : "/";
export const publicStaticPath = process.env.NODE_ENV === "production" ? "/" : "/";
export const onHoldAttachPath = process.env.NODE_ENV === "production" ? "/Onhold/" : "http://172.16.1.44/Onhold/";

export function Err401() {

    loadComplete();

    if (Local.get("userId")) {
        var myModalEl = document.getElementById('reloginmodal');
        var modal = bootstrap.Modal.getInstance(myModalEl);

        if (modal && !modal._isShown) {
            modal.show();
        }
    } else {

        // sessionStorage.removeItem("authuser");
        //   console.log("Err401 return;");
        window.location.href = process.env.NODE_ENV === "production" ? "/" : "/";
        //    window.location.href = process.env.NODE_ENV === "production" ? "/normanaustralia" : "/";
        // let router = useRouter();
        //  router.push({ name: "home" });

        //   let loginUrl = "../index?returnurl=" + window.location.href;

    }


    //sessionStorage.removeItem("authuser");
    //if (Session.get("deviceid")) {

    //    if (parent && parent.window) {
    //        parent.window.location.href = loginUrl;
    //    } else {
    //        window.location.href = loginUrl;
    //    }

    //} else {
    //    window.location.href = loginUrl;
    //}
}
export function startLoading() {
    if (document.getElementById("pageloading")) document.getElementById("pageloading").style.display = "";
}
export function loadComplete() {
    if (document.getElementById("pageloading")) document.getElementById("pageloading").style.display = "none";
}
export function isLoading() {
    if (document.getElementById("pageloading"))
        if (document.getElementById("pageloading").style.display.toLowerCase() != "none") return true;
    return false;
}
export async function checkToken() {
    let tenantid = Session.get("cbdid_token") || "";
    let deviceid = Local.get("deviceid") || "";

    if (tenantid && deviceid) {
        return true;
        //try {
        //    return true;
        //    if (Session.get("lastchktoken"))
        //    {

        //        let olddate = new Date(Number(Session.get("lastchktoken")));
        //        let cm = (new Date().getTime() - olddate.getTime()) / 1000 / 60;

        //        if (cm < 30) {
        //            return true;
        //        }
        //    }
        //    let res = await get("account/RefreshToken", { deviceId: deviceid, tenantId: tenantid });
        //    if (res.success) {

        //        return true;
        //    } else {
        //        return false;
        //    }
        //} catch {
        //    return false;
        //}
    } else {
        return false;
    }
}
export function get(url, params) {
    return new Promise((resolve, reject) => {
        //     axios.get(baseUrl + (url.indexOf("?") > -1 ? url : url + "?") + qs.stringify(params))

        axios.get(baseUrl + url, {
                params: params
            })
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err)
            })
    })
}

//  Form Data
//  headers: {
//    "Content-Type": 'application/x-www-form-urlencoded; charset=UTF-8'
//  }

export function post(url, params = {}, headers) {
    return new Promise((resolve, reject) => {
        if (headers == undefined) {

            axios.post(baseUrl + url, JSON.stringify(params), {
                    headers: {
                        "Content-Type": "application/json;charset=UTF-8"
                    }
                }).then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err)
                })
        } else {

            axios.post(baseUrl + url, qs.stringify(params), headers)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err)
                })
        }

    });
}
export function postWithFiles(url, data) {
    var configHeader = {
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    const accessToken = getToken();
    if (accessToken) {
        configHeader['Authorization'] = `Bearer ${accessToken}`;

        // 判断 accessToken 是否过期
        let jwt = decryptJWT(accessToken);
        let exp = getJWTDate(Number(jwt.exp));
        if (new Date() >= exp) {
            // 获取刷新 token
            const refreshAccessToken = getRefreshToken(); // Local.get(refreshAccessTokenKey);
            if (refreshAccessToken) {
                configHeader['X-Authorization'] = `Bearer ${refreshAccessToken}`;
            }
        }
    }
    const $http = axios.create({
        baseURL: baseUrl,
        timeout: 20000,
        headers: configHeader,
        transformRequest: [function(data, headers) {
            const ContentType = headers['Content-Type'] || ''
            if (ContentType.indexOf('application/json') >= 0) {
                return JSON.stringify(data)
            }
            return data instanceof FormData ? data : qs.stringify(data, { encode: false });
        }],
        transformResponse: [function(data) {
            return data;
        }, function(data) {
            return data;
        }],
    })
    return $http.post(url, data);
}
export function postGetFiles(url, params = {}, filename) {
    axios.post(baseUrl + url, JSON.stringify(params), {
        responseType: 'blob',
        headers: {
            "Content-Type": "application/json;charset=UTF-8"
        }
        //  "authorization": "Bearer " + sessionStorage.getItem("authuser")
    }).then(res => {
        if (res.size) {
            let blob = new Blob([res]);
            const elink = document.createElement('a');
            elink.download = filename;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);

        } else {
            errorvue("download error.");
        }
    }).catch(err => {
        errorvue(err)
    })
}
export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(baseUrl + url, data)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err)
            })
    })
}

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(baseUrl + url, data)
            .then(response => {
                resolve(response);
            }, err => {
                reject(err)
            })
    })
}
export function getLoginInfo() {
    let loginInfo = {
        userid: Local.get("userId") || "",
        username: Session.get("userName") || "",
        showPrice: Session.get("ABC") == "Y", //showPrice
        showPriceList: Session.get("BCD") == "Y", //priceList
        showAnswer: Session.get("CDE") == "Y", //Answer
        srhTmpOrders: (Session.get("DEF") == "*" || Session.get("DEF") == "M"), //rights
        hasCheckout: Session.get("EFG") == 0 || Session.get("EFG") == "0", //isCash
        hasRga: (Session.get("FGH") || "0").indexOf("1") > -1, //hasRga
        isAU: Session.get("DEF") == "M", //rights
        accountName: Session.get("accountName") || "", //AccountName
        securityLevel: parseInt(Session.get("GHI") || "0"), //
        caneditjob: Session.get("CEJ") == "Y", //CanEditJob
        grantlist: Session.get("GRL"),
        newsletters: Session.get("CUT"),
        maxDisCount: Session.get("MaxDisCount"),
        canAirShutters: Session.get("CanAirShutters"),
        canWaiveWarranty: Session.get("CanWaiveWarranty"),
        showSF: Session.get("DEF") == "S",
    };
    // console.log("loginInfo",loginInfo);
    let xi = "";
    for (var attr in loginInfo) {
        if (loginInfo[attr] != null)
            xi += loginInfo[attr].toString();
    }
    if (window.btoa)
        xi = window.btoa(xi);
    if (!Session.get("xi")) {
        Session.set("xi", xi);
    } else {
        if (Session.get("xi") != xi) {

            Session.remove("cbdid_token");
            Session.remove("islogined");
        }
    }
    return loginInfo;
}


export function isNullOrEmpty(str) {
    if (str == null || str === "" || str == undefined) return true;
    return false;
}

export function checkMessageHolder() {
    if (!document.getElementById('liveToastholder')) {
        var docholer = document.createElement('div')
        docholer.id = "liveToastholder";
        docholer.className = "position-fixed";
        docholer.classList.add("position-fixed");
        docholer.classList.add("bottom-0");
        docholer.classList.add("end-0");
        docholer.classList.add("p-3");
        docholer.style.zIndex = "11";
        document.body.appendChild(docholer);
    }
}

export function alertvue(message, callback) {
    //checkMessageHolder();
    //if (!document.getElementById('livealertToast')) {
    //    document.getElementById("liveToastholder").innerHTML = "<div  class=\"toast\" role=\"alert\" id=\"livealertToast\" aria-live=\"assertive\" aria-atomic=\"true\"><div class=\"toast-header\"><svg class=\"bd-placeholder-img rounded me-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\"><rect width=\"100%\" height=\"100%\" fill=\"#ffc107\"></rect></svg><strong class=\"me-auto\">Alert</strong><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"toast\" aria-label=\"Close\"></button></div><div class=\"toast-body\" id=\"livealertToastbody\"></div></div>";
    //}
    //document.getElementById('livealertToastbody').innerHTML = message;
    //var toast = new bootstrap.Toast(document.getElementById('livealertToast'));
    //toast.show({ delay: 10000 });
    if (typeof callback == "function")
        callback();
    try {
        window.alert(message);
    } catch {
        failed(message);
    }
}

export function failed(message, callback) {
    checkMessageHolder();
    if (!document.getElementById('livefailedToast')) {
        document.getElementById("liveToastholder").innerHTML = "<div  class=\"toast\" role=\"alert\" id=\"livefailedToast\" aria-live=\"assertive\" aria-atomic=\"true\"><div class=\"toast-header\"><svg class=\"bd-placeholder-img rounded me-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\"><rect width=\"100%\" height=\"100%\" fill=\"#ffc107\"></rect></svg><strong class=\"me-auto\">Failed</strong><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"toast\" aria-label=\"Close\"></button></div><div class=\"toast-body\" id=\"livefailedToastbody\"></div></div>";
    }
    document.getElementById('livefailedToastbody').innerHTML = message;
    var toast = new bootstrap.Toast(document.getElementById('livefailedToast'));
    toast.show();
    if (typeof callback == "function")
        callback();
}

export function success(message, callback) {
    checkMessageHolder();
    if (!document.getElementById('livesuccessToast')) {
        document.getElementById("liveToastholder").innerHTML = "<div  class=\"toast\" role=\"success\" id=\"livesuccessToast\" aria-live=\"assertive\" aria-atomic=\"true\"><div class=\"toast-header\"><svg class=\"bd-placeholder-img rounded me-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\"><rect width=\"100%\" height=\"100%\" fill=\"#007aff\"></rect></svg><strong class=\"me-auto\">Success</strong><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"toast\" aria-label=\"Close\"></button></div><div class=\"toast-body\" id=\"livesuccessToastbody\"></div></div>";
    }
    document.getElementById('livesuccessToastbody').innerHTML = message;
    var toast = new bootstrap.Toast(document.getElementById('livesuccessToast'));
    toast.show();

    window.setTimeout(2000, () => { toast.hide(); });

    if (typeof callback == "function")
        callback();
}

export function errorvue(message, callback) {
    if (message && message.status && message.status == 401) {
        console.error(message);
        return;
    }
    checkMessageHolder();
    if (!document.getElementById('liveerrorToast')) {
        document.getElementById("liveToastholder").innerHTML = "<div  class=\"toast\" role=\"error\" id=\"liveerrorToast\" aria-live=\"assertive\" aria-atomic=\"true\"><div class=\"toast-header\"><svg class=\"bd-placeholder-img rounded me-2\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" preserveAspectRatio=\"xMidYMid slice\" focusable=\"false\"><rect width=\"100%\" height=\"100%\" fill=\"#ff0000\"></rect></svg><strong class=\"me-auto\">Error</strong><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"toast\" aria-label=\"Close\"></button></div><div class=\"toast-body\" id=\"liveerrorToastbody\"></div></div>";
    }
    document.getElementById('liveerrorToastbody').innerHTML = message;
    var toast = new bootstrap.Toast(document.getElementById('liveerrorToast'));
    toast.show();
    if (typeof callback == "function")
        callback();
}
export function checkrequired(obj) {
    // console.log(obj)
    if (obj.required) {
        if (obj.value == "") {
            obj.classList.add('is-invalid');
            return false;
        } else {
            obj.classList.remove('is-invalid');
        }
    }

    if (obj.getAttribute("rules")) {

        switch (obj.getAttribute("rules")) {
            case "number":
                if (isNaN(obj.value)) {
                    obj.classList.add('is-invalid');
                    throw new Error('Please input number');

                }
                if (parseFloat(obj.value) == 0) {
                    obj.classList.add('is-invalid');
                    throw new Error('Please input number');
                }
                break;
            case "int":
                break;
        }
        // obj.
    }
    return true;
}


export function checkRange(n, m, params, name) {
    const min = parseFloat(n);
    const max = parseFloat(m);
    if (parseFloat(params) < min || parseFloat(params) > max) {
        alert(`${name}`);
    }
}

export function limitToNumbers(obj, key) {
    let value = obj[key].toString().replace(/[^0-9]/g, '');
    obj[key] = value === '' ? '' : (parseInt(value, 10) + '');
}

export function limitStrToNumbers(str) {
    str = str.replace(/[^0-9]/g, '');
}

export function limitTodecimal(obj, key) {
    console.log(obj, key, obj[key])
    obj[key] = obj[key].toString().replace(/[^\d^\.]+/g, '')
        .replace(/^0+(\d)/, '$1')
        .replace(/^\./, '0.')
        .match(/^\d*(\.?\d{0,1})/g)[0] || ''

    console.log(obj, key, obj[key])
}



export function setNumberNullToZero(messageItems, arr = []) {
    for (let att in messageItems) {
        if (messageItems[att] === null && (!arr || arr.indexOf(att) === -1)) {
            messageItems[att] = 0;
        }
    }
}

export function setZeroToNumberNull(obj, arr) {
    for (let key in obj) {
        if (typeof obj[key] === 'number' && obj[key] === 0 && (!arr || arr.indexOf(key) === -1)) {
            obj[key] = null;
        }
    }
    return obj;
}

export function WindowResize() {
    const isLargeScreen = ref(window.innerWidth >= 992);
    const isMediumScreen = ref(window.innerWidth >= 576 && window.innerWidth < 992);
    const isSmallScreen = ref(window.innerWidth < 576);

    const handleResize = () => {
        isLargeScreen.value = window.innerWidth >= 992;
        isMediumScreen.value = window.innerWidth >= 576 && window.innerWidth < 992;
        isSmallScreen.value = window.innerWidth < 576;
    };

    onMounted(() => {
        window.addEventListener('resize', handleResize);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', handleResize);
    });

    return {
        isSmallScreen,
        isMediumScreen,
        isLargeScreen
    };
}

export function checkOrderHeadAddress(state, city, postcode, street, callback) {
    post("Account/AddressVerify", [state, city, postcode, street]).then((res) => {
        if (res.success == false) {
            failed(res.message);
            return;
        } else {
            if (callback && callback instanceof Function) {
                callback(res.resultdata);
            }
        }
    })
}

// 防抖
export function debounce(fn, delay) {
    var timer;

    return function() {
        var context = this;
        var args = arguments;

        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(function() {
            timer = null;
            fn.apply(context, args);
        }, delay || 500);
    };
}

export function getFirstWord(str) {
    return str.trimStart().split(/\s+/)[0];
}

/**
 * 针对帘子类side by side  
 * 该方法遍历本item是否有被其他item绑定 
 */
export async function checkoutSideBySide(ProductType, OrderId, line_no) {
    try {
        const dataPromise = new Promise((resolve, reject) => {
            getModel(OrderId, "tmp", (data) => {
                try {
                    // console.log("getModel", data);
                    resolve(data);
                } catch (error) {
                    reject(error);
                }
            });
        });

        const data = await dataPromise;
        let sideArr = [];
        if (data.itemdetails) {
            sideArr = [...(JSON.parse(data.itemdetails).rows)];
            const tempItem = {
                CB: sideArr.find(item => parseInt(item.matchitemno) === parseInt(line_no)),
                RL: sideArr.find(item => parseInt(item.togetherwith) === parseInt(line_no)),
                PS: sideArr.find(item => parseInt(item.togetherwith) === parseInt(line_no)),
                CC: sideArr.find(item => parseInt(item.togetherwith) === parseInt(line_no))

            }[ProductType];
            console.log("Order/GetNewItemNo", tempItem,sideArr);
            return tempItem;
        }
    } catch (error) {
        errorvue("checkoutSideBySide error.");
        return false;
    }
}

export function RoomVal(str) {
    let sVal = str.replace(/^\s*/g, "");
    let reg = /[\s-]/; // 匹配空格或连字符
    let result = sVal.split(reg);
    sVal = result[0];
    return sVal.toUpperCase();
}
export function AccessVerify(menuid){
    var res=false;
    var grantl=getLoginInfo().grantlist;
    var aaa=grantl[menuid];
   
    res=grantl[menuid]=="1"?true:false;
    if(Session.get("DEF") == "M")
    {
        res=true;
    }
    return res;
    
  }
